<div class="step-container step-certificados-layout">
  <div class="step-header step-header-with-info">
    <div class="step-header-title-block">
      <div class="step-header-icon"><i class="fas fa-user-shield" aria-hidden="true"></i></div>
      <h2>Información del Usuario</h2>
    </div>
    <div class="step-header-user-info">
      <span class="header-user-name">{{ usuario.nombre }}</span>
      <span class="header-meta"><i class="fas fa-shield-alt" aria-hidden="true"></i> Certifirma Digital Virtual: <strong>{{ usuario.cantidadTokens }}</strong></span>
      <span class="header-meta"><i class="fas fa-certificate" aria-hidden="true"></i> Certificados: <strong>{{ certificados.length }}</strong></span>
    </div>
  </div>

  <div class="step-certificados-body two-cols">
    <div class="col-left">
      <h5 class="section-title">
        <i class="fas fa-certificate section-title-icon" aria-hidden="true"></i>
        Mis Certificados ({{ certificados.length }})
      </h5>
      <div class="cert-list">
        <div *ngFor="let c of certificados" class="cert-row">
          <div class="cert-icon"><i class="fas fa-shield-alt" aria-hidden="true"></i></div>
          <div class="cert-details">
            <span class="cert-policy">{{ c.cn || c.nombre }}</span>
            <span class="cert-meta" *ngIf="c.titulo">Título: {{ c.titulo }}</span>
            <span class="cert-meta" *ngIf="c.politica">{{ c.politica }}</span>
            <span class="cert-meta" *ngIf="c.serial">Serial number: {{ c.serial }}</span>
            <span class="cert-meta" *ngIf="c.serialNumber && c.serialNumber !== c.serial">Serial: {{ c.serialNumber }}</span>
            <span class="cert-meta">Válido hasta: {{ c.validoHasta }}</span>
          </div>
          <span class="cert-badge" [class.activo]="c.estado === 'Activo'">{{ c.estado }}</span>
        </div>
      </div>
    </div>

    <div class="col-right">
      <ng-container *ngIf="!showPasswordForm">
        <div class="panel-restablecimiento">
          <div class="oportunidades-card">
            <span class="op-label">Oportunidades restantes:</span>
            <span class="op-badge">{{ oportunidades }}/10</span>
          </div>
          <p class="important-short">El cambio aplica a todos los certificados vigentes. Máx. 10 intentos.</p>
          <div class="panel-actions">
            <button type="button" class="btn btn-primary" (click)="mostrarFormularioContrasena()" [disabled]="oportunidades <= 0">Continuar</button>
            <button type="button" class="btn btn-secondary" (click)="onCancelar()">Cancelar</button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showPasswordForm">
        <div class="panel-password">
          <h5 class="panel-title"><i class="fas fa-lock" aria-hidden="true"></i> Nueva contraseña</h5>
          <form [formGroup]="form" (ngSubmit)="ngSubmit()" novalidate>
            <label class="label-document">Nueva contraseña *</label>
            <div class="auth-input-wrap auth-input-wrap-password" [class.is-invalid]="hasError('nueva')">
              <input
                [type]="showNueva ? 'text' : 'password'"
                formControlName="nueva"
                class="auth-input"
                [placeholder]="isCcsw5 ? '10 a 12 caracteres' : '8 a 12 caracteres'"
                [attr.maxlength]="passwordMaxLength">
              <button
                type="button"
                class="password-toggle-btn"
                (mousedown)="showNueva = true"
                (mouseup)="showNueva = false"
                (mouseleave)="showNueva = false"
                (touchstart)="showNueva = true; $event.preventDefault()"
                (touchend)="showNueva = false"
                (touchcancel)="showNueva = false"
                (pointerdown)="showNueva = true"
                (pointerup)="showNueva = false"
                (pointercancel)="showNueva = false"
                tabindex="0"
                [attr.aria-label]="'Mantenga pulsado para ver la contraseña'">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </div>
            <div class="invalid-feedback d-block" *ngIf="hasError('nueva')">{{ getErrorMessage('nueva') }}</div>
            <ul class="req-list">
              <li [class.ok]="hasMinLength">{{ isCcsw5 ? '10–12 caracteres' : '8–12 caracteres' }}</li>
              <li [class.ok]="hasUpper">Mayúscula</li>
              <li [class.ok]="hasNumber">Número</li>
              <li [class.ok]="hasSpecial">Especial</li>
            </ul>
            <label class="label-document">Confirmar *</label>
            <div class="auth-input-wrap auth-input-wrap-password" [class.is-invalid]="hasError('confirmar') || (form.get('confirmar')?.touched && !passwordsMatch())">
              <input
                [type]="showConfirmar ? 'text' : 'password'"
                formControlName="confirmar"
                class="auth-input"
                placeholder="Repita la contraseña"
                [attr.maxlength]="passwordMaxLength">
              <button
                type="button"
                class="password-toggle-btn"
                (mousedown)="showConfirmar = true"
                (mouseup)="showConfirmar = false"
                (mouseleave)="showConfirmar = false"
                (touchstart)="showConfirmar = true; $event.preventDefault()"
                (touchend)="showConfirmar = false"
                (touchcancel)="showConfirmar = false"
                (pointerdown)="showConfirmar = true"
                (pointerup)="showConfirmar = false"
                (pointercancel)="showConfirmar = false"
                tabindex="0"
                [attr.aria-label]="'Mantenga pulsado para ver la contraseña'">
                <i class="fas fa-eye" aria-hidden="true"></i>
              </button>
            </div>
            <div class="invalid-feedback d-block" *ngIf="hasError('confirmar')">{{ getErrorMessage('confirmar') }}</div>
            <div class="invalid-feedback d-block" *ngIf="form.get('confirmar')?.touched && form.get('confirmar')?.value && !passwordsMatch()">No coinciden</div>
            <div class="panel-actions">
              <button type="button" class="btn btn-secondary" (click)="showPasswordForm = false">Atrás</button>
              <button type="submit" class="btn btn-primary" [disabled]="form.invalid || !passwordsMatch()">Actualizar contraseña</button>
            </div>
          </form>
        </div>
      </ng-container>
    </div>
  </div>
</div>
